<template>
    <v-container fluid pa-0 v-if="!$store.getters.progress" style="padding-bottom: 10% !important">
        <v-layout row wrap>
            <v-flex xs12>
                <v-card class="flex pa-0">
                    <v-toolbar flat color="grey lighten-4">
                        <v-toolbar-title class="grey--text text--darken-4">Dettaglio Carta Fedeltà</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <v-btn @click="$eventBusUtility.goTo($router, 'fidelitycards-edit', model.id)" slot="activator" icon>
                                <v-icon color="primary">mode_edit</v-icon>
                            </v-btn>
                            <span>Modifica Carta Fedeltà</span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-container fluid pa-0 px-2>
                        <v-layout row :wrap="$vuetify.breakpoint.smAndDown">
                            <v-flex xs12 sm12 md6 lg6>
                                <v-list two-line class="w100p">
                                <v-subheader>Carta Fedeltà</v-subheader>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">dvr</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Codice</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.code }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>                                    
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">data_usage</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Tipo</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.type }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>                                    
                                    <v-list-tile>
                                        <v-list-tile-avatar class="v-avatar-show">
                                            <v-avatar v-if="model.creator_avatar"
                                                class="custom-avatar"
                                                :size="26" 
                                                v-ripple
                                                :style="{'background-image': 'url(' + model.creator_avatar + ')'}">
                                            </v-avatar>
                                            <v-avatar v-else :class="$eventBusUtility.bgColor(model.creator_id)" :size="26">
                                                <span class="white--text fs14" v-if="model.creator">{{ model.creator.charAt(0) }}</span>
                                            </v-avatar>
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Creatore</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.creator }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Creato il</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.created_at }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>                             
                                </v-list>
                            </v-flex>
                            
                            <v-divider vertical class="hidden-sm-and-down"></v-divider>

                            <v-flex xs12 sm12 md6 lg6>
                                <v-list two-line class="w100p">
                                <v-subheader>Cliente</v-subheader>
                                    <v-list-tile @click="$eventBusUtility.goTo($router, 'customers-edit', model.customer_id)">
                                        <v-list-tile-action>
                                            <v-icon color="primary">person</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Nome</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.customer_name }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
										    <v-btn icon>
										        <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
										    </v-btn>
										</v-list-tile-action>
                                    </v-list-tile>                                    
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">phone</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Telefono</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.customer_primary_telephone }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>                                    
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">email</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Email</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.customer_primary_email }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">cake</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Compleanno</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.customer_birthday }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                            </v-flex>
                        </v-layout>
                        <v-divider v-if="model.description"></v-divider>
                        <v-layout row wrap pt-2 pb-2 v-if="model.description">
                            <template>
                                <v-subheader class="pl-4 pt-3">Descrizione</v-subheader>
                                <v-flex xs12>
                                    <v-card class="flex" elevation="0">
                                        <div class="blockquote pl-4 pr-4 fs14i" v-html="model.description"></div>
                                    </v-card>
                                </v-flex>
                            </template>     
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>

            <v-flex xs12 pt-3>
                <has-many-crud
					:title="'Movimenti Carta'"
                    :action-icon="'swap_horiz'"
                    :model-def="'movements'"
                    :sub-filters="'fidelitycard_id'"
					:sub-filters-id="id"
                    :action-position="'absolute'"
                    :position-left="true"
                    :position-right="false"
                    :direction="'right'"
					:footerComponent="'ResumeFooter'"
                ></has-many-crud>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
import HasManyCrud from '@/components/HasManyCrud'

export default {
	name: 'product',
	components: {
		HasManyCrud
	},
	props: {
		id: Number
	},

	data() {
		return {
			model: {},
			url: 'fidelitycards/',
			saved: false
		}
	},

	created() {
		this.axios.get(this.url + this.id).then(response => {
			// get body data
			this.model = response.data.model
			this.$store.commit('endProgress')
		},
		response => {
			// error callback
		})
	}
}
</script>

<style scoped>
div >>> .v-list__tile {
  height: 58px;
  -webkit-user-select: auto;
  user-select: auto;
}
</style>
